<template>
    <div class="r-auth-forget">
        <y-form-title
            :title="title"
            :description="description"
        />

        <!-- Recover Request -->
        <y-loading
            v-if="state === 'forget-request'"
            :active="$wait.is('fetch-request-config')"
            position="relative"
            height="100%"
        >
            <y-validator
                v-if="usernameFields"
                @submit="recoverRequest"
            >
                <y-input
                    v-model="username"
                    type="text"
                    name="username"
                    :max-length="getChannel === 'sms' ? 11 : null"
                    :format="usernameFieldOptions().format"
                    :label="usernameFieldOptions().label"
                    :placeholder="usernameFieldOptions().placeholder"
                    class="mb-10"
                />

                <y-button
                    block
                    flat
                    :color="color"
                    type="submit"
                    :disabled="!username || getChannel === 'invalid'"
                    loading-on="submitting-forget-request"
                >
                    {{ $t('auth.forget.buttons.send_code') }}
                </y-button>
            </y-validator>
        </y-loading>

        <!-- Verify Token -->
        <div v-if="state === 'verify-token'">
            <y-validator @submit="verifyToken">
                <div class="d-flex ltr">
                    <y-input
                        v-for="i in tokenCharCount"
                        :key="i"
                        v-model="token[i]"
                        type="number"
                        name="token"
                        no-label
                        align="center"
                        max-length="1"
                        :format="usernameFieldOptions().format"
                        :label="usernameFieldOptions().label"
                        class="mb-10 mx-1 typo-center"
                        @input="changeInput(i, $event)"
                    />
                </div>
            </y-validator>

            <div
                v-if="counter"
                class="d-flex align-items-center justify-content-between mb-12"
            >
                <span class="typo-body-2">
                    {{ tokenTrans.text }}
                </span>

                <div v-if="showResend">
                    <y-button
                        text
                        size="small"
                        :color="color"
                        @click="recoverRequest"
                    >
                        {{ tokenTrans.resend }}
                    </y-button>
                </div>
                <div
                    v-else
                    class="typo-body-2"
                >
                    <span>
                        {{ tokenTrans.resend }}
                    </span>
                    <span>
                        {{ digits(counter, $i18n.locale) }}
                    </span>
                </div>
            </div>

            <y-row>
                <y-col>
                    <y-button
                        block
                        flat
                        outline
                        :color="color"
                        @click="state = 'forget-request'"
                    >
                        {{ $t('auth.forget.buttons.edit_username') }}
                    </y-button>
                </y-col>
                <y-col>
                    <y-button
                        block
                        flat
                        :color="color"
                        :disabled="verifyCode.length !== tokenCharCount"
                        loading-on="submitting-verify-token"
                        @click="verifyToken"
                    >
                        {{ $t('auth.forget.buttons.confirm') }}
                    </y-button>
                </y-col>
            </y-row>
        </div>

        <!-- Set New Password -->
        <div v-if="state === 'reset-password'">
            <y-validator @submit="resetPassword">
                <y-input
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    name="password"
                    :label="$t('fields.new_password')"
                    :placeholder="$t('fields.placeholder', [$t('fields.new_password')])"
                    :icon-append="showPassword ? 'eye-slash' : 'eye'"
                    :icon-append-action="showPasswordChars"
                    icon-prefix="far"
                    class="mb-10"
                />

                <y-input
                    v-model="password2"
                    :type="showPassword2 ? 'text' : 'password'"
                    name="password2"
                    :label="$t('fields.new_password2')"
                    :placeholder="$t('fields.placeholder', [$t('fields.new_password2')])"
                    :icon-append="showPassword2 ? 'eye-slash' : 'eye'"
                    :icon-append-action="showPassword2Chars"
                    icon-prefix="far"
                    class="mb-14"
                />

                <y-button
                    block
                    flat
                    :color="color"
                    type="submit"
                    :disabled="!password || !password2"
                    loading-on="submitting-reset-password"
                >
                    {{ $t('auth.forget.buttons.reset_password') }}
                </y-button>
            </y-validator>
        </div>

        <!-- Recaptcha -->
        <y-recaptcha
            v-if="recaptcha && recaptcha.active"
            ref="recaptcha"
            :site-key="recaptcha.key"
            :size="recaptcha.size"
            @verify="getToken"
        />
    </div>
</template>

<script>
    import {
        YValidator, YInput,
    } from '@components';
    import AuthForgetMixin from '@rogues/Auth/mixins/Forget';
    import isEmpty from 'lodash.isempty';

    export default {
        name: 'ForgetFormBlock',

        components: {
            YValidator,
            YInput,
        },

        mixins: [
            AuthForgetMixin,
        ],

        methods: {
            isEmpty,
        },
    };
</script>
